import { MediaObserver } from '@angular/flex-layout';
import {
	ChangeDetectorRef,
	Component,
	Inject,
	Input,
	OnInit,
} from '@angular/core';
import {
	MatDialog,
	MatDialogRef,
	MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { ReplyChangeService } from '../../../services/reply-change.service';
import { UntypedFormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FundraiserService } from '../../../services/fundraiser.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { AccountService } from 'src/app/pages/account/services/account.service';
import { Router } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { NgFor, NgClass, NgIf, CurrencyPipe } from '@angular/common';
import { FlexModule } from '@angular/flex-layout/flex';
import { MatButtonModule } from '@angular/material/button';

import { ThankDonarComponent } from 'src/app/shared/components/thank-donar/thank-donar.component';
import { MatTabsModule } from '@angular/material/tabs';
import { UserIconComponent } from 'src/app/shared/components/user-icon/user-icon.component';

@Component({
    selector: 'app-donor-list-full',
    templateUrl: './donor-list-full.component.html',
    styleUrls: ['./donor-list-full.component.scss'],
    standalone: true,
    imports: [MatButtonModule, FlexModule, NgFor, NgClass, ExtendedModule, MatCardModule, NgIf, MatFormFieldModule, MatInputModule, FormsModule, ReactiveFormsModule, MatIconModule, MatProgressSpinnerModule, CurrencyPipe, MatTabsModule, UserIconComponent]
})
/** *Donor List Full Component */
export class DonorListFullComponent implements OnInit {
	donorData: any;
	replyButton: boolean = false;
	replyIndex: number = -1;
	replyForm = new UntypedFormControl('', [
		Validators.required,
		Validators.maxLength(200),
		Validators.pattern(
			/^[\p{L}\p{N}\p{P}\p{S}\s\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{1FAC0}-\u{1FAFF}\u{1FB00}-\u{1FBFF}\u{1FC00}-\u{1FCFF}\u{1FD00}-\u{1FDFF}\u{1FE00}-\u{1FEFF}\u{1FF00}-\u{1FFFF}\u{2B05}\u{1F004}]*$/u
		),
	]);
	isLoggedInUserAdmin: boolean = false;
	@Input() currentFundraiserID: string | any;
	donarDataSlice: any;
	count: number = 0;
	dataSize: number = 20;
	loadDataCheck: boolean = false;
	loadDataCheckTop: boolean = false;
	donationCountTop: number = 0;
	donorPlaceholder = $localize`:@@donor_list_full_sendMessageToDonor_placeholder:Send Message to donor`;
	isDonorListLoading: boolean = true;
	page: number = 1;
	totalPages: number = 1;
	isLoading: boolean = false;
	donationCount: number = 0;
	slug: any;
	lang: any;
	showReplyForm: any = true;
	removeTextArea: boolean = false;
	donor = {};
	messageReply: any;

	topContributors: any;
	label_donorList_tab1 = $localize`:@@donor_list_tab1_label: Recent Donations`;
	label_donorList_tab2 = $localize`:@@donor_list_tab2_label: Top Contributors`;

	constructor(
		public dialog: MatDialog,
		public dialogRef: MatDialogRef<DonorListFullComponent>,
		public media: MediaObserver,
		public replyService: ReplyChangeService,
		private fundRaiserService: FundraiserService,
		public _notificationService: NotificationService,
		public fundraiserService: FundraiserService,
		public _accountService: AccountService,
		public router: Router,
		@Inject(MAT_DIALOG_DATA) public data: any,
		ref: ChangeDetectorRef
	) {}

	ngOnInit(): void {
		// Extract the slug from the current URL or get it from the fundraiser service
		this.slug = this.router.url.split('?')[0].substring(13) || null;
		this.slug = this.fundRaiserService.getCurrentFundraiserSlug();

		// Get the current locale/language ID from the account service
		this.lang = this._accountService.getLocaleId();

		// Fetch the donor list for the current fundraiser
		this.fundraiserService
			.getDonorList(this.slug, this.page, this.lang)
			.subscribe((res: any) => {
				// Update the donor data and donation count
				this.donorData = res.data?.result?.result;
				this.donationCount = res.data?.result?.count;

				// Check if the total donations are less than or equal to 20
				if (this.donationCount <= 20) {
					this.loadDataCheck = true;
				} else {
					this.loadDataCheck = false;
				}

				// Calculate the total number of pages for pagination
				this.totalPages = this.getPageNumbers();
			});

		// Subscribe to the current user's admin status
		this.replyService.currentUserValue.subscribe((data) => {
			this.isLoggedInUserAdmin = data;
		});

		// Set the admin status from the injected data
		this.isLoggedInUserAdmin = this.data['isLoggedInUserAdmin'];
		this.getTopContributors();
	}
	getInitial(name: string): string {
		if (!name) {
			return 'AN'; // If no name provided, return 'AN'
		}

		const nameParts = name.trim().split(' ');

		if (nameParts.length === 1) {
			// Single name: return first two initials of the first name
			return nameParts[0].substring(0, 2).toUpperCase();
		} else if (nameParts.length >= 2) {
			// Full name: return initials of first and last name
			const firstInitial = nameParts[0].charAt(0).toUpperCase();
			const lastInitial = nameParts[nameParts.length - 1]
				.charAt(0)
				.toUpperCase();
			return `${firstInitial}${lastInitial}`;
		}

		return 'AN'; // Fallback condition
	}
	/**
	 * Function to handle the reply message button functionality
	 * @param index - Index of the donor data
	 */
	replyMessage(index: any) {
		try {
			this.showReplyForm = true; // Show the reply form
			this.replyButton = true; // Enable the reply button
			this.replyIndex = index; // Set the reply index
			this.messageReply = this.donorData[this.replyIndex].reply_message; // Get the reply message for the selected donor

			// Check if the reply message is empty or undefined
			if (!this.messageReply || this.messageReply.trim() === '') {
				this.messageReply = this.donorPlaceholder; // Set the placeholder if the reply message is empty
			} else {
				this.replyForm.setValue(this.messageReply); // Set the reply form value with the existing reply message
			}
		} catch (error) {
			// Handle any errors that occur during the reply message process
			console.error('Error handling reply message:', error);
			this._notificationService.openNotification(
				$localize`:@@reply_message_error:Error handling reply message. Please try again.`,
				'',
				'error'
			);
		}
	}

	/**
	 * Function to post the reply message
	 * @param input - The reply message input
	 * @param replyIndex - The index of the donor data
	 * @param i - The index in the donor data array
	 */
	postReply(input: any, replyIndex: any, i: any) {
		const y: any = replyIndex;

		// Create the object to be sent in the request
		let obj = {
			donation_order_id: replyIndex,
			thanks_message: input,
		};

		// Call the service to update the donor reply
		this.fundRaiserService.updateDonorReply(obj).subscribe(
			(data) => {
				// Update the donor data with the new reply message
				this.donorData[i].reply_message = input;
				// Notify the user of the successful message send
				this._notificationService.openNotification(
					$localize`:@@donor_list_full_messageSent:The message is successfully sent`,
					'OK',
					'success'
				);
				this.replyButton = false; // Disable the reply button
			},
			(error) => {
				// Handle any errors that occur during the reply post process
				console.error('Error posting reply message:', error);
				this._notificationService.openNotification(
					$localize`:@@reply_message_post_error:Error posting reply message. Please try again.`,
					'',
					'error'
				);
			}
		);
	}

	//** *Load More Data Logic */
	showMoreData() {
		this.isLoading = true;
		this.page = this.page + 1;
		if (this.page <= this.totalPages) {
			if (this.donorData?.length <= this.donorData?.length) {
				this.fundraiserService
					.getDonorList(this.slug, this.page, this.lang)
					.subscribe((data: any) => {
						this.isDonorListLoading = false;
						this.donorData = [
							...this.donorData,
							...(Array.isArray(data?.data?.result?.result)
								? data.data.result.result
								: []),
						];
						this.isLoading = false;
						if (this.donorData.length % this.donationCount == 0) {
							this.loadDataCheck = true;
						}
					});
			} else {
				this.loadDataCheck = false;
			}
		} else {
			this.loadDataCheck = false;
		}
	}
	showMoreTopContributorData() {
		this.isLoading = true;
		this.page = this.page + 1;
		if (this.topContributors?.length <= this.topContributors?.length) {
			this.fundRaiserService.getTopContributors(this.slug, this.lang, this.page)
				.subscribe((data: any) => {
					this.isDonorListLoading = false;
					this.topContributors = [
						...this.topContributors,
						...(Array.isArray(data?.data?.result)
						? data.data.result
						: []),
					]
					this.isLoading = false;
					if (this.topContributors.length % this.donationCountTop == 0) {
						this.loadDataCheckTop = true;
					}
				});
		} else {
			this.loadDataCheckTop = false;
		}
	}

	/** *get Page Number For showing more card logic  */
	getPageNumbers(): number {
		this.totalPages = Math.floor(this.donationCount / 20);
		if (this.donationCount % 20 !== 0) {
			this.totalPages++;
			return this.totalPages;
		} else {
			return this.totalPages;
		}
	}
	onCloseClick() {
		this.dialogRef.close();
	}
	onCancelClick(index: any) {
		this.replyForm.reset();
		this.showReplyForm = false;
		return (this.replyButton = false), (this.showReplyForm = true);
	}

	/**
	 * Fetches the top contributors for the current fundraiser campaign and updates the component state.
	 */
	getTopContributors() {
		// Invoke the service method to fetch top contributors
		this.fundRaiserService.getTopContributors(this.slug, this.lang, this.page).subscribe({
			// Handle successful response
			next: (res: any) => {
				// Extract the contributors' data from the response
				this.topContributors = res?.data?.result;
				this.donationCountTop = res.data?.count;

				if (this.donationCountTop <= 5) {
					this.loadDataCheckTop = true;
				} else {
					this.loadDataCheckTop = false;
				}

			},
			// Handle errors during the API call
			error: (error: any) => {
				// Log the error for debugging
				console.error('Error fetching top contributors:', error);
			},
		});
	}
	openDialog(index: any): void {
		this.dialog.open(ThankDonarComponent, {
			width: '80vh',
			maxHeight: '98vh',
			data: { count: this.donorData[index] },
		});
	}
}
